import { Button, Tooltip } from 'flowbite-react';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { useAppSelector } from '../../Reducers/store';
import WarrantyApi from '../../Api/WarrantyApi';
import { Warranty } from '../../Models/Warranty';
import WarrantyListTable from './WarrantyListTable';
import { HiPlus } from 'react-icons/hi';
import { Link } from 'react-router-dom';

export default function WarrantyMyClaims() {
  const { userModel } = useAppSelector((state) => state.user);
  const [warrantyListData, setWarrantyListData] = useState<Warranty[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getWarranties = useCallback(() => {
    if (userModel) {
      try {
        setIsLoading(true);
        return WarrantyApi.getMyWarranties()
          .then((res) => {
            setWarrantyListData(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  }, [userModel]);

  useEffect(() => {
    getWarranties();
  }, [getWarranties]);

  function deleteWarranty(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this?'
    );

    // if (shouldRemove) {
    //   WarrantyApi.deleteWarranty(id)
    //     .then((res) => {
    //       if (res.data.success) {
    //         toast.success(res.data.message);
    //         getWarranties();
    //       } else {
    //         toast.success('Error while deleting item');
    //       }
    //     })
    //     .catch((err) => {
    //       toast.error('Error: ' + err);
    //     });
    // }
  }
  function checkAccess() {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1 flex items-end'>
            <div className='flex flex-1'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>My Warranty Claims</div>
              </h1>
            </div>
            {checkAccess() && (
              <div className=''>
                <Tooltip content='New Warranty Claim'>
                  <Link to={`/warranty/claim`}>
                    <Button type='button' className='buttonMain'>
                      <HiPlus size={20} />
                    </Button>
                  </Link>
                </Tooltip>
              </div>
            )}
          </div>
        </div>
        <div className='relative'>
          {isLoading && <Loader />}
          <div className='w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-200px)] overflow-y-auto'>
            <WarrantyListTable
              data={warrantyListData}
              deleteWarranty={deleteWarranty}
            />
          </div>
        </div>
      </div>
    </>
  );
}
